import classNames from 'classnames';

import { Bell, Calendar, Database, LayoutPanelTop, Puzzle, Users } from 'lucide-react';
import UsersAppIcon from 'modules/ud-ui/components/icon/users-icon';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import MenuItemIcon from '../menu-item/menu-item';
import useUnreadNotifications from 'modules/notifications/ui/hooks/use-unread-notifications';
import useIsDev from 'shared/hooks/use-is-dev';

type Props = { className?: string };

const UDMenuSystemNavigation = React.memo((props: Props) => {
  const { unreadCount } = useUnreadNotifications();
  const isDev = useIsDev();

  let badge = unreadCount > 0 ? { label: unreadCount.toString() } : undefined;

  return (
    <div className={classNames('d-flex flex-column', props.className)}>
      <MenuItemIcon to={Pages.NOTIFICATIONS.INDEX} icon={<Bell size={16} />} label={'Уведомления'} badge={badge} />
      <MenuItemIcon to={Pages.SCHEDULE.INDEX} icon={<Calendar size={16} />} label={'Расписание'} />
      <MenuItemIcon to={Pages.ORGANIZERS.INDEX} icon={<Users size={16} />} label={'Организаторы'} adminOnly={true} />
      <MenuItemIcon to={Pages.ROLES_MANAGER.INDEX} icon={<UsersAppIcon width={16} height={16} />} label={'Пользователи'} />
      <MenuItemIcon to={Pages.TEMPLATE.INDEX} icon={<LayoutPanelTop size={16} />} label={'Шаблоны'} />
      <MenuItemIcon to={Pages.MIGRATION.INDEX} icon={<Database size={16} />} label={'Миграция'} adminOnly={true} />
      <MenuItemIcon to={Pages.TESTS.COMPONENTS} icon={<Puzzle size={16} />} label={'Компоненты'} adminOnly={true} hide={!isDev} />
    </div>
  );
});

export default UDMenuSystemNavigation;
